export default "__VITE_PUBLIC_ASSET__850204d1__"